/**
 * Configuration the Message type.
 */
export const MESSAGE_TYPE = {
  NORMAL: Symbol('NORMAL'), // Right to Left
  FROM_TOP: Symbol('FROM_TOP'), // From Top
  FROM_BOTTOM: Symbol('FROM_BOTTOM') // From Bottom
}
